export default __webpack_public_path__ + "static/media/smartGating.b5d2ee6d.svg";